import { FC } from 'react';

import type { PicsartIcon } from '@quicktools/shared-components/types';

export interface IValues {
  product: string;
  description: string;
  callToAction: string;
  tone: string;
  businessType: string;
  specialOffers: string;
  characterLimit: string;
  tellUsAboutYourself: string;
  textToParaphrase: string;
  language: string;
  wordToStart: string;
  numberOfResults: string;
  keywords: string;
  purpose: string;
  adWriterRadioValue: string;
  describeYourImage: string;
  paragraphTitle: string;
  textToBeSummarised: string;
  format: string;
  textPurpose: string;
  describeText: string;
  describeScene: string;
  numberOfColors: string;
  ideaGeneratorTopic: string;
  blogIdeaGeneratorTopic: string;
  bookIdeaGeneratorTopic: string;
  businessIdeaGeneratorTopic: string;
  contentIdeaGeneratorTopic: string;
  drawingIdeaGeneratorTopic: string;
  giftIdeaGeneratorTopic: string;
  paintingIdeaGeneratorTopic: string;
  sideHustleIdeaGeneratorTopic: string;
  startupIdeaGeneratorTopic: string;
  storyIdeaGeneratorTopic: string;
  articleWriterTopic: string;
  articleWriterDetails: string;
  seoCheckboxValue: boolean;
  length: string;
  creativity: string;
  describeStory: string;
  sloganPurpose: string;
  sloganWords: string;
  describeOutline: string;
  includeIdeas: string;
  outlinePurpose: string;
  describeTopic: string;
  metaTitleCheckbox: boolean;
  dropdown01: string;
  dropdown02: string;
  inputValue: string;
  essayInput: string;
  essayDetails: string;
  createInput: string;
  createDetails: string;
  titleGeneratorTopic: string;
  blogTitleGeneratorTopic: string;
  bookTitleGeneratorTopic: string;
  contentTitleGeneratorTopic: string;
  documentTitleGeneratorTopic: string;
  landingPageTitleGeneratorTopic: string;
  socialMediaPostTitleGeneratorTopic: string;
  storyTitleGeneratorTopic: string;
  videoTitleGeneratorTopic: string;
  videoScriptGeneratorTopic: string;
  videoScriptStyle: string;
  videoScriptLength: string;
  videoScriptComplexity: string;
  blogTitleGeneratorType: string;
  bookTitleGeneratorType: string;
  contentTitleGeneratorType: string;
  documentTitleGeneratorType: string;
  titleGeneratorType: string;
  landingPageTitleGeneratorType: string;
  socialMediaPostTitleGeneratorType: string;
  storyTitleGeneratorType: string;
  videoTitleGeneratorType: string;
  promptGeneratorTopic: string;
  promptGeneratorDetails: string;
  textPromptGeneratorTopic: string;
  textPromptGeneratorDetails: string;
  imagePromptGeneratorTopic: string;
  imagePromptGeneratorDetails: string;
  videoPromptGeneratorTopic: string;
  videoPromptGeneratorDetails: string;
  codePromptGeneratorTopic: string;
  codePromptGeneratorDetails: string;
  paragraphGeneratorTopic: string;
  paragraphGeneratorDetails: string;
  keywordsGeneratorTopic: string;
  keywordsGeneratorNumber: string;
}

export interface ICopywriterCategoriesMainPorps {
  id: number;
  label: string;
  src?: FC<string>;
  otherTool?: boolean;
}

export enum PromptPartType {
  template,
  string,
  stringVariants,
}

export type PromptPart = {
  type: PromptPartType;
  template?: string;
  variants?: { [key: string]: string };
};

export type BodyParam = {
  value: string;
  analyticsValue: string;
  noTrim?: boolean;
  label?: string;
  promptPart?: PromptPart;
};

type AiModel = 'gpt-3.5-turbo' | 'gpt-4' | 'gpt-4-32k';

export type ToolCategory = number;

export type CopywriterCategory = {
  id: ToolCategory;
  label: string;
  name: string;
  otherTool?: boolean;
  path: {
    self: string;
    landing: string;
  };
  systemRolePromptPart?: string;
  generateMoreCount?: number;
  generateCount?: number;
  params: BodyParam[];
  additionalPromptPart?: PromptPart;
  rephrasePromptPart?: PromptPart;
  splitChoices?: boolean;
  model: AiModel;
  rephrase: boolean;
  hasOneResult?: boolean;
  hideGenerateMore?: boolean;
  excludeFinalPromptPart?: boolean;
  formatResults?: (input: string) => string;
};

export type AllCategories = Record<ToolCategory, CopywriterCategory>;

export type DropdownEntry = {
  title: string;
  value: string;
};

export type MenuSubcategory = {
  id: number;
  category: number;
  text: string;
  icon: PicsartIcon;
};

export enum MenuCategoryType {
  Generate = 'generate',
  Edit = 'edit',
  Content = 'content',
  Business = 'business',
  Marketing = 'marketing',
  Create = 'create',
  MyWriter = 'my-writer',
}

export type MenuCategory = {
  // parent: MenuCategoryType;
  type: MenuCategoryType;
  icon: PicsartIcon;
  text: string;
  subcategories: MenuSubcategory[];
};

export interface IRephrasedResult {
  id: string;
  result: string;
  changedResult?: string;
  isSensitive: boolean;
}

export enum ResultType {
  Common = 'common',
  Recent = 'recent',
  Rephrase = 'rephrase',
}

export interface IResult extends IRephrasedResult {
  category: number;
  type: ResultType;
  changedResult?: string;
  rephrasedResults: IRephrasedResult[];
  isRephrasing?: boolean;
}

export interface ICategoryResult {
  category: number;
  actualResults: IResult[];
}

export interface IInitialContext {
  results: ICategoryResult[];
  generatingResults: boolean;
}
